import r from "./_baseIsNative.js";
import i from "./_getValue.js";
var v = r, u = i;
function o(a, t) {
  var e = u(a, t);
  return v(e) ? e : void 0;
}
var s = o;
export {
  s as default
};
//# sourceMappingURL=_getNative.js.map
